<div class="credit-line-details-content">
  @if (isLoading) {
    <section class="loading-state">
      <caixa-webcomponent-shimmer
        width="35%"
        height="28px"
        borderRadius="6px"
        marginBottom="28px"
      />

      <caixa-webcomponent-shimmer
        width="26%"
        height="20px"
        borderRadius="4px"
        marginBottom="18px"
      />

      @for (row of [1, 2, 3, 4, 5, 6]; track row) {
        <div class="loading-row">
          <caixa-webcomponent-shimmer
            width="100%"
            height="20px"
            borderRadius="4px"
          />
          <caixa-webcomponent-shimmer
            width="100%"
            height="20px"
            borderRadius="4px"
          />
          <caixa-webcomponent-shimmer
            width="100%"
            height="20px"
            borderRadius="4px"
          />
        </div>
      }
    </section>
  } @else if (hasError || !creditLineData) {
    <section class="error-state">
      <img
        class="error-image"
        [src]="errorImageSrc"
        alt="Erro ao carregar detalhes da linha de crédito"
      />
      <h3 class="error-title">
        {{ errorTitle }}
      </h3>
      <p class="error-subtitle">
        {{ errorSubtitle }}
      </p>
    </section>
  } @else {
    <div class="credit-line-title">
      <h1 class="title-text">{{ creditLineData?.productName || 'N/A' }}</h1>
    </div>

    <div class="credit-line-info-section">
      <h3 class="section-title">{{ modalConfig.sectionTitle }}</h3>

      <div class="info-grid">
        @for (row of modalConfig.rows; track $index) {
          @if (row.sectionTitle) {
            <div class="section-divider">
              <h3 class="section-title">{{ row.sectionTitle }}</h3>
            </div>
          }
          <div class="info-row">
            @for (item of row.items; track $index) {
              <div class="info-item">
                <span class="info-label">
                  {{ item.label }}
                  @if (item.tooltip) {
                     <i
                      class="cds-icon-filled-question c-icon-strong"
                      placement="top"
                      [cdsTooltip]="item.tooltip"
                    ></i>
                  }
                </span>
                <span
                  class="info-value"
                  [class]="item.format"
                >
                  {{ getDetailValue(item.key) }}
                </span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }

</div>
